import { INTERNAL_MATERIAL_PURPOSE_OPTIONS } from '../../constants/internalMaterialPurposes';

export const INTERNAL_DESTINATION_TEXTS = {
  incomplete: 'Completá depósito, destino, fecha y al menos un material con cantidad válida.',
  title: 'Destino del pedido',
  kind: 'Solicitar para',
  project: 'Proyecto',
  internal: 'Uso interno',
  destination: 'Destino operativo',
  search: 'Buscar destino',
  purpose: 'Motivo',
  detail: 'Detalle del motivo',
  kinds: [{ value: 'project', label: 'Proyecto' }, { value: 'internal', label: 'Uso interno' }],
  purposes: INTERNAL_MATERIAL_PURPOSE_OPTIONS,
};
